import React from 'react'
import {useParams,useNavigate } from 'react-router-dom';
import {useState,useEffect} from 'react';
import {ip} from "../../../config";
import SpinLoader from '../../Miscel/SpinLoader';


const AddImages = () => {

    const navigate = useNavigate();

    useEffect(() => {
        document.getElementById("spinloader").classList.add("invisible")
    },[])
    function addNewAlumniPhoto(e){
        e.preventDefault();
        var file = document.getElementById("photo").files[0];
        document.getElementById("spinloader").classList.remove("invisible");
        
        
        const formData = new FormData();
        formData.append('file',file);

        if(file==null || file.length==0) {
            alert("No file selected.");
            document.getElementById("spinloader").classList.add("invisible");
            return;
        }

        fetch(ip+'/images', {
            method: 'POST',
            headers: {Authorization: 'Basic ' + localStorage.getItem('sessionKey')},
            body: formData        
        }).then(response => {                        
            
            document.getElementById("spinloader").classList.add("invisible");
            if(response.status===200){
                return response.json();           
            }else{
               alert("Error in uploading photo.. Please Contact admin!")
            }
        }
        ).then(data => {            
            uploadToCloud(data.url);
        }).catch(error => {
            alert("Error in uploading photo.. Please Contact admin!");
            console.log(error);
        })

                                     
        
    }

    function uploadToCloud(url){
        fetch(ip+"/events/"+id+"/images"+"?fileUrl="+url, {
            method: 'POST',
            headers: {Authorization: 'Basic ' + localStorage.getItem('sessionKey')}
        })    .then(response => {
            if (response.status === 201) {
                return response.json();
            } else {
                alert("Error in adding event. Contact admin");
            }
        }
        ).then(data => {
            document.getElementById("photo").value = "";
            console.log(data);
            setImageCount(imageCount+1);
        }
        ).catch(error => {
            console.log(error);
        }
        );     
    }

    function goBack(){
        navigate("/event/"+id);
    }
    const {id} = useParams();
    const[imageCount,setImageCount] = useState(0);
    return ( 
        <div className="container">

        <SpinLoader/>
        <form className="form-horizontal" id="form-2">

            <div className="h3 mb-3 mark p-3 mt-2">Newly uploaded Images {imageCount}</div>

            <div className="form-group">
                <label className="mb-2" htmlFor="exampleInputEmail1">Upload Images</label>
                <input type="file" className="form-control" id="photo" aria-describedby="emailHelp" placeholder="Upload Alumni Image" />
            </div>
            <div className="d-flex justify-content-between">
                <button type="submit" onClick={(e)=> addNewAlumniPhoto(e)} className="btn btn-primary mt-3">Upload</button>
                <button type="submit" onClick={(e)=> {goBack()}} className="btn btn-success mt-3">Finish Uploading</button>
            </div>
            
        </form>      
        </div>
     );
}
 
export default AddImages;